<div *ngIf="loading" class="loading-container">
    <mat-spinner></mat-spinner> <!-- 🔄 Indicatore di caricamento -->
</div>
<div *ngIf="!loading">
    <!-- <div *ngIf="invalidCompanySelected" class="invalid-company-message">
        <h2>{{ 'CONS_DUBAI.SELECT_COMPANY_WARNING' | translate }}</h2>
    </div> -->

    <!-- <div *ngIf="!invalidCompanySelected" class="container"> -->
    <div class="container">
        <div class="intro-container">
            <h2>{{ 'CONS_DUBAI.DUBAI_CONSUNTIVATORE_TITLE' | translate }}</h2>
            <p>
                {{ 'CONS_DUBAI.DUBAI_CONSUNTIVATORE_DESCRIPTION_FILTERS' | translate }}
                <mat-icon class="inline-icon">search</mat-icon>.
                <br />
                {{ 'CONS_DUBAI.DUBAI_CONSUNTIVATORE_DESCRIPTION_PART1' | translate }}
                <mat-icon class="inline-icon">close</mat-icon>.
                {{ 'CONS_DUBAI.DUBAI_CONSUNTIVATORE_DESCRIPTION_PART2' | translate }}
                <mat-icon class="inline-icon">person_add</mat-icon>.
                {{ 'CONS_DUBAI.DUBAI_CONSUNTIVATORE_DESCRIPTION_PART3' | translate }}
                <mat-icon class="inline-icon">delete</mat-icon>.
                {{ 'CONS_DUBAI.DUBAI_CONSUNTIVATORE_DESCRIPTION_PART4' | translate }}
                <span style="font-size: 14px; color: #f4d03f; vertical-align: middle;">★</span>
                {{ 'CONS_DUBAI.DUBAI_CONSUNTIVATORE_DESCRIPTION_STAR' | translate }}.
                {{ 'CONS_DUBAI.DUBAI_CONSUNTIVATORE_DESCRIPTION_PART5' | translate }}
                <mat-icon class="inline-icon">qr_code</mat-icon>
                {{ 'CONS_DUBAI.DUBAI_CONSUNTIVATORE_DESCRIPTION_DOWNLOAD_QRCODE' | translate }}.
            </p>



        </div>
        <div class="filters-select-row" style="display: flex; gap: 16px; margin-bottom: 20px; align-items: flex-end;">
            <kendo-multiselect [data]="countryList" [(ngModel)]="selectedCountries" [textField]="'Country'"
                [valueField]="'Country'" [filterable]="true"
                [placeholder]="'CONS_DUBAI.PLACEHOLDER_SELECT_COUNTRY' | translate" (valueChange)="onCountryChange()">
            </kendo-multiselect>

            <kendo-multiselect class="full-width" [data]="filteredSocietaList" [(ngModel)]="selectedSocieta"
                [textField]="'DESCRIZIONE'" [valueField]="'ID'" [filterable]="true"
                (filterChange)="onSocietaFilterChange($event)"
                [placeholder]="'CONS_DUBAI.PLACEHOLDER_SELECT_SOCIETA' | translate" (valueChange)="onSocietaChange()"
                [disabled]="loadingSocieta">
            </kendo-multiselect>

            <kendo-multiselect class="full-width" [data]="filteredSediList" [(ngModel)]="selectedSedi"
                [textField]="'NomeSede'" [valueField]="'IdSede'" [filterable]="true"
                (filterChange)="onSediFilterChange($event)"
                [placeholder]="'CONS_DUBAI.PLACEHOLDER_SELECT_SEDI' | translate" [disabled]="loadingSedi">
            </kendo-multiselect>


            <!-- Bottoni filtri -->
            <div class="filters-buttons-row" style="display: flex; gap: 4px;">
                <button mat-icon-button (click)="onSearchFilters()" [matTooltip]="'CONS_DUBAI.SEARCH_BTN' | translate">
                    <mat-icon>search</mat-icon>
                </button>
            </div>
        </div>

        <kendo-multiselect class="full-width" [data]="filteredOperators" [(ngModel)]="selectedOperators"
            [textField]="'name'" [valueField]="'id'" [filterable]="true"
            [placeholder]="'CONS_DUBAI.SELECT_OPERATORS_PLACEHOLDER' | translate"
            (filterChange)="onOperatorFilterChange($event)" [valuePrimitive]="false">

            <!-- Template per la lista dropdown -->
            <ng-template kendoMultiSelectItemTemplate let-dataItem>
                <span>
                    {{ dataItem.name }}
                    <span *ngIf="dataItem.ruolo === 'Operaio Capo Squadra'"
                        style="font-size: 10px; color: #f4d03f;vertical-align: super;">★</span>
                </span>
            </ng-template>
            <ng-template kendoMultiSelectTagTemplate let-dataItem>
                <span>
                    {{ dataItem.name }}
                    <span *ngIf="dataItem.ruolo === 'Operaio Capo Squadra'"
                        style="font-size: 10px; color: #f4d03f;">★</span>
                </span>
            </ng-template>

        </kendo-multiselect>




        <div class="grid-layout">
            <!-- 📋 Lista Capi Squadra -->
            <div class="team-container">
                <div class="search-wrapperr">
                    <div class="search-wrapper-flex">
                        <mat-form-field class="search-field">
                            <input matInput [placeholder]="'CONS_DUBAI.SEARCH_TEAM_LEADER_PLACEHOLDER' | translate"
                                [(ngModel)]="searchTeamLeader">
                        </mat-form-field>

                        <button mat-icon-button (click)="downloadPdfQrcode()"
                            [matTooltip]="'CONS_DUBAI.DOWNLOAD_QRCODE_TOOLTIP' | translate">
                            <mat-icon fontIcon="qr_code"></mat-icon>
                        </button>
                    </div>

                    <button mat-icon-button [matTooltip]="'CONS_DUBAI.SEARCH_TEAM_LEADER_TOOLTIP' | translate"
                        class="info-icon-absolute risorse-icon-info">
                        <mat-icon fontIcon="info" class="info-icon-small"></mat-icon>
                    </button>
                </div>



                <div *ngFor="let leader of filteredTeamLeaders" class="team-leader-box">
                    <mat-card>
                        <mat-card-title>
                            <span>
                                {{ sanitizeValue(leader.name, 'Missing Subject') }}
                                <span *ngIf="getTranslatedRole(leader.ruolo) === 'ROLE_TEAM_LEADER'"
                                    class="star-icon">★</span>
                            </span>
                            ({{ sanitizeValue(leader.CodiceFiscale, 'Missing Fiscal Code') }})
                        </mat-card-title>

                        <mat-card-content>
                            <h4>{{ "CONS_DUBAI.ASSIGNED_PROJECTS_TITLE" | translate }}</h4>
                            <div cdkDropList id="leader-{{ leader.Id }}" [cdkDropListData]="leader.projects"
                                [cdkDropListConnectedTo]="connectedLists" (cdkDropListDropped)="drop($event, leader)"
                                class="drop-container">

                                <div *ngFor="let project of leader.projects" cdkDrag class="drag-item">
                                    <p><strong>{{ sanitizeValue(project.code) }}</strong> -
                                        {{ sanitizeValue(project.nameSubject, 'Missing Subjecte') }} -
                                        {{ sanitizeValue(project.nameBuilding, 'Missing Address') }}
                                    </p>

                                    <button class="remove-btn" (click)="removeProject(leader, project)">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>


                <mat-paginator #paginatorLeaders [length]="totalLeaders" [pageSize]="pageSizeLeaders"
                    [pageSizeOptions]="[5, 10, 15]" (page)="updatePaginationLeaders($event)">
                </mat-paginator>
            </div>

            <!-- 📋 Lista Commesse -->

            <div class="project-container">
                <div class="search-wrapperr">
                    <mat-form-field class="full-width">
                        <input matInput [placeholder]="'CONS_DUBAI.SEARCH_PROJECT_PLACEHOLDER' | translate"
                            [(ngModel)]="searchProject" (ngModelChange)="onSearchChange($event)">
                    </mat-form-field>
                    <button mat-icon-button [matTooltip]="'CONS_DUBAI.SEARCH_PROJECT_TOOLTIP' | translate"
                        class="info-icon-absolute">
                        <mat-icon fontIcon="info" class="info-icon-small"></mat-icon>
                    </button>
                </div>


                <mat-card class="projects-container">
                    <mat-card-title>{{ 'CONS_DUBAI.PROJECT_LIST_TITLE' | translate }}</mat-card-title>
                    <mat-card-content>
                        <!-- 🔄 Mostra il loading se isLoadingProjects è true -->
                        <div *ngIf="isLoadingProjects" class="loading-container-project">
                            <mat-spinner diameter="40"></mat-spinner>
                        </div>

                        <!-- ✅ Mostra i risultati solo quando isLoadingProjects è false -->
                        <div *ngIf="!isLoadingProjects">
                            <div cdkDropList #projectList="cdkDropList" id="projectList"
                                [cdkDropListData]="filteredProjects" [cdkDropListConnectedTo]="connectedLists"
                                (cdkDropListDropped)="drop($event)" class="drop-container">

                                <div *ngFor="let project of filteredProjects" cdkDrag class="drag-item">
                                    <p><strong>{{ sanitizeValue(project.code) }}</strong> -
                                        {{ sanitizeValue(project.nameSubject, 'Missing Subject') }} -
                                        {{ sanitizeValue(project.nameBuilding, 'Missing Address') }}
                                    </p>

                                    <!-- 🔽 Bottone visibile solo se ci sono operatori selezionati -->
                                    <button *ngIf="selectedOperators.length > 0" mat-icon-button
                                        [matTooltip]="'CONS_DUBAI.ASSOCIATE_OPERATORS_TOOLTIP' | translate"
                                        (click)="assignOperatorsToProject(project)">
                                        <mat-icon>person_add</mat-icon>
                                    </button>
                                    <!-- 🗑️ Bottone per rimuovere la commessa da tutti gli operatori -->
                                    <button class="deleteAllOperators"
                                        *ngIf="isProjectAssignedToAnyTeamLeader(project.id)" mat-icon-button
                                        color="warn"
                                        [matTooltip]="'CONS_DUBAI.REMOVE_ALL_OPERATORS_TOOLTIP' | translate"
                                        (click)="removeProjectFromAllTeamLeaders(project)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>

                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>

                <mat-paginator #paginatorProjects [length]="totalProjects" [pageSize]="pageSizeProjects"
                    [pageSizeOptions]="[5, 10, 15]" (page)="updatePaginationProjects($event)">
                </mat-paginator>
            </div>
        </div>
    </div>


</div>